import React, { useState, useEffect } from 'react';
import downArrow from "../../images/down-arrow.svg"
import upArrow from "../../images/up-arrow.png"


import './table_of_contents_mobile.scss';

const TableOfContentsMobile = ({ sectionContent }) => {
  const [parsedData, setParsedData] = useState([]);
  const [changeArrow, setChangeArrow] = useState(false);
  const [activeTab, setActiveTab] = useState('');
  let html = sectionContent;

  useEffect(() => {
    // Create a temporary div element to render and extract the HTML content
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Extract the data from the rendered HTML
    const listItems = tempDiv.querySelectorAll('li');
    const parsedObject = [];

    listItems.forEach((li) => {
      const link = li.querySelector('a');
      if (link) {
        parsedObject.push({
          text: link.textContent,
          href: link.getAttribute('href'),
        });
      }
    });

    setParsedData(parsedObject);

    // Clean up the temporary div element
    tempDiv.remove();
  }, [html]);

  const handleItemClick = () => {
    setChangeArrow(!changeArrow);
    if (parsedData.length > 0) {
      setParsedData((prevData) => {
        return prevData.map((item) => ({
          ...item,
          open: !item.open,
        }));
      });
    }
  };

  // Function to handle scroll event
  const handleScroll = () => {
    const tocMobile = document.querySelector('.table_of_contents_mobile');

    if (tocMobile) {
      const scrollY = window.scrollY;
      const isSticky = scrollY >= 50; // Adjust this value as needed

      if (isSticky) {
        tocMobile.style.top = '50px';
      } else {
        tocMobile.style.top = '0';
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    // Clean up the scroll event listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="table_of_contents_mobile" >
      <ul className="table-of-content-list">
        <li className="first-item">
          {parsedData.length > 0 && (
            <button
              onClick={() => handleItemClick()}
              className={parsedData[0].open ? 'active' : ''}
            >
              {activeTab !== '' ? activeTab : parsedData[0].text}
              {changeArrow === true ? <img src={upArrow} alt="Drop down arrow" style={{width:'10px', height:'5px', marginLeft:'5px'}}/> : <img src={downArrow} alt="Drop down arrow" style={{width:'10px', height:'10px', marginLeft:'5px'}}/>}
            </button>
          )}
          {parsedData[0]?.open && (
            <ul className="inner-list">
              {parsedData.map((item, index) => (
                <li className="inner-list-item text-truncate" key={index} onClick={() => setActiveTab(item.text)}>
                  <a href={item.href}>{item.text}</a>
                </li>
              ))}
            </ul>
          )}
        </li>
      </ul>
    </div>
  );  
  };

  export default TableOfContentsMobile;


  

// step 1: parse content data into html => object 
// step 2: take parsed object and convert into jsx
// step 3: take jsx content and add event listner to hide/reveal content
